import { withJsonpSupport } from '@angular/common/http';
import { ICompaniesShortList, IParkerProfileForParkerTable, IParkerProfileQueuedForImport } from '../../interfaces';

export class ParkerImportPrep {
  constructor(private companyList: ICompaniesShortList[]) {}

  CreateParkerImportListForParkerTable(
    parkerPrepList: IParkerProfileQueuedForImport[],
    lotNumber: string,
    userName: string,
  ): IParkerProfileForParkerTable[] {
    let preppedParkerList: IParkerProfileForParkerTable[] = [];
    let ii: number;

    for (ii = 0; ii < parkerPrepList.length; ii++) {
      let preppedParker: IParkerProfileForParkerTable = {} as IParkerProfileForParkerTable;
      let cardNumberAsString: string = parkerPrepList[ii].cardNumber;
      let newParkerId: string = this.CreateNewParkerId();

      while (false == this.IsParkerIdUnique(newParkerId, preppedParkerList)) {
        newParkerId = this.CreateNewParkerId();
      }

      preppedParker = {
        ...parkerPrepList[ii],
        lotNumber: lotNumber,
        userName: userName,
        parkerId: newParkerId,
        companyId: this.GetCompanyIdByCompanyName(parkerPrepList[ii].companyName),
      };
      preppedParker.rateNumber = preppedParker.rateNumber.toString();

      //Coerce cardNumber to be string
      preppedParker.cardNumber = preppedParker.cardNumber.toString();

      preppedParkerList.push(preppedParker);
    }

    return preppedParkerList;
  }

  private GetCompanyIdByCompanyName(companyName: string): string {
    let companyId: string = '';
    let ii: number;

    for (ii = 0; ii < this.companyList.length; ii++) {
      if (companyName.toLocaleUpperCase() == this.companyList[ii].companyName.toLocaleUpperCase()) {
        companyId = this.companyList[ii].companyId;
      }
    }

    return companyId;
  }

  private IsParkerIdUnique(newParkerId: string, parkerList: IParkerProfileForParkerTable[]): boolean {
    let status: boolean = true;
    let ii: number;

    for (ii = 0; ii < parkerList.length; ii++) {
      if (parkerList[ii].parkerId == newParkerId) {
        status = false;
        break;
      }
    }

    return status;
  }

  CreateNewParkerId(): string {
    let newParkerId: string = '';
    let currentDate: Date = new Date();
    let month: string = currentDate.getMonth().toString();
    let day: string = currentDate.getDate().toString();
    let year: string = currentDate.getFullYear().toString();
    let hour: string = currentDate.getHours().toString();
    let minute: string = currentDate.getMinutes().toString();
    let second: string = currentDate.getSeconds().toString();
    let millisecond: string = currentDate.getMilliseconds().toString();

    if (month.length == 1) month = '0' + month;

    if (day.length == 1) day = '0' + day;

    if (year.length == 1) year = '0' + year;

    if (hour.length == 1) hour = '0' + hour;

    if (minute.length == 1) minute = '0' + minute;

    if (second.length == 1) second = '0' + second;

    if (millisecond.length == 1) millisecond = '00' + millisecond;

    if (millisecond.length == 2) millisecond = '0' + millisecond;

    const randomLastThreeOfParkerId: number = Math.floor(Math.random() * 999) + 1;
    let lastThreeParkerIdDisplay: string = '000';

    if (randomLastThreeOfParkerId.toString().length == 1)
      lastThreeParkerIdDisplay = '00' + randomLastThreeOfParkerId.toString();

    if (randomLastThreeOfParkerId.toString().length == 2)
      lastThreeParkerIdDisplay = '0' + randomLastThreeOfParkerId.toString();

    if (randomLastThreeOfParkerId.toString().length == 3)
      lastThreeParkerIdDisplay = randomLastThreeOfParkerId.toString();

    newParkerId = `${month}${day}${year}${hour}${minute}${second}${millisecond}${lastThreeParkerIdDisplay}`;

    return newParkerId;
  }
}
